import { generatePath, useHistory, useParams } from 'react-router-dom';
import Page from 'flow/components/Setting/Page';
import Button from 'flow/components/ui-components/Button';
import RouteLink from 'flow/components/ui-components/RouteLink';
import { useModal } from 'flow/contexts/ModalProvider';
import useAppContext from 'flow/hooks/useAppContext';
import useProfiles from 'flow/hooks/useProfiles';
import { useAppSelector } from 'flow/hooks/useRedux';
import { selectIsAdmin } from 'flow/selectors/own-extension-selectors';
import { ExtensionKey } from 'flow/types/EntityKeys';
import { routes } from 'flow/types/routes';

const Modes = () => {
    const history = useHistory();
    const { extensionKey } = useParams<{ extensionKey: ExtensionKey }>();
    const { i18next } = useAppContext();
    const { openModal } = useModal();
    const { profiles } = useProfiles(extensionKey);
    const isAdmin = useAppSelector(selectIsAdmin);

    return (
        <Page
            header={i18next.t('ai-coworker.settings.modes')}
            onClickBack={() =>
                history.push(
                    generatePath(
                        routes['pbx.aicoworker.extensionKey.settings'],
                        {
                            extensionKey,
                        },
                    ),
                )
            }
            action={
                isAdmin ? (
                    <Button
                        hideTextOnOnePanel={true}
                        iconKey="add"
                        className="bg-main py-1 text-white"
                        onClick={() =>
                            openModal('addAiMode', {
                                extensionKey,
                            })
                        }
                    >
                        {i18next.t('ai-coworker.settings.modes.add')}
                    </Button>
                ) : null
            }
        >
            {profiles?.map((mode) => (
                <RouteLink
                    key={mode.get('key')}
                    to={generatePath(
                        routes['ai-coworker.settings.modes.profileKey'],
                        {
                            extensionKey,
                            profileKey: mode.get('key'),
                        },
                    )}
                    state={{ from: history.location.pathname }}
                >
                    {mode.get('description')}
                </RouteLink>
            ))}
        </Page>
    );
};

export default Modes;
